import { render, staticRenderFns } from "./FpMarkdown.vue?vue&type=template&id=3b2036aa&scoped=true"
import script from "./FpMarkdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./FpMarkdown.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FpMarkdown.vue?vue&type=style&index=0&id=3b2036aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2036aa",
  null
  
)

export default component.exports